import { render, staticRenderFns } from "./WorkspaceConfiguration.vue?vue&type=template&id=4ecf2e9e&scoped=true&"
import script from "./WorkspaceConfiguration.vue?vue&type=script&lang=js&"
export * from "./WorkspaceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceConfiguration.vue?vue&type=style&index=0&id=4ecf2e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf2e9e",
  null
  
)

export default component.exports